@if (institutionId > 0) {
  <div id="submodule-notes" class="cw-module-card">
    <!-- Header -->
    <div class="cw-flex-row">
      <!-- Modul-Titel -->
      <h2>{{ 'GENERAL.NOTES' | translate }}</h2>
      <!-- Toolbar -->
      @if (!editMode) {
        <phscw-toolbar
          componentIdentifier="institutions-notes"
          [componentConnection]="$any(this)"
          [buttonAdd]="true"
          printContent="submodule-notes">
        </phscw-toolbar>
      }
    </div>
    <!-- Grid -->
    @if (!editMode) {
      <phscw-grid
        #gridInstitutionsNotes
        gridId="institutionsNotes"
        [simpleGrid]="true"
        [gridData]="data"
        [gridColumns]="gridColumns"
        [gridDisplayedColumns]="gridDisplayedColumns">
      </phscw-grid>
    }
    <!-- Funktion um weitere Einträge zu laden -->
    @if (!editMode) {
      <phscw-grid-load-more
        gridId="institutionsNotes"
        [enabled]="loadMoreEnabled"
        [visible]="loadMoreVisible"
        [gridPageCounter]="gridPage">
      </phscw-grid-load-more>
    }
    <!-- Formular (für EditMode) -->
    @if (editMode) {
      <form #institutionsNotesForm="ngForm" (ngSubmit)="clickSubmit()">
        <!-- IDs -->
        <input type="hidden" name="id" [(ngModel)]="dataItem.id" />
        <input type="hidden" name="institution_id" [(ngModel)]="institutionId" />
        <input type="hidden" name="person_id" [(ngModel)]="dataItem.person_id" />
        <!-- Infos zur Person -->
        @if (dataItem.person_id && (dataItem.person_lastname || dataItem.person_firstname)) {
          <div
            class="cw-flex-row cw-input">
            <span class="cw-input-label">{{ 'GENERAL.PERSON' | translate }}</span>
            <div class="cw-flex-column">
              <span class="cw-input-span cw-overlay-toggle">
                <span (click)="openOverlayInfoDialog($event, 'PeopleData', dataItem.person_id)"
                  >{{ dataItem.person_lastname
                  }}@if (dataItem.person_firstname) {
                  , {{ dataItem.person_firstname }}
                  }</span
                  >
                </span>
              </div>
            </div>
          }
          <!-- Infos zur Einrichtung -->
          @if ((dataItem.institution_id || noteId === 0) && institutionName) {
            <div class="cw-flex-row cw-input">
              <span class="cw-input-label">{{ 'GENERAL.INSTITUTION' | translate }}</span>
              <div class="cw-flex-column">
                <span class="cw-input-span cw-overlay-toggle">
                  <span (click)="openOverlayInfoDialog($event, 'InstitutionsData', institutionId)">{{
                    institutionName
                  }}</span>
                </span>
              </div>
            </div>
          }
          <!-- Eingabefelder -->
          @if (titleVisible) {
            <phscw-input-text
              [editMode]="editMode"
              label="{{ 'GENERAL.TITLE' | translate }}"
              name="title"
              inputId="title"
            [(ngModel)]="dataItem.title"></phscw-input-text>
          }
          <phscw-input-textarea
            [editMode]="editMode"
            label="{{ 'GENERAL.NOTE' | translate }}"
            name="note"
            inputId="note"
            [(ngModel)]="dataItem.note"
          [required]="true"></phscw-input-textarea>
          <!-- Infos zum Mitarbeiter -->
          @if (dataItem.employee_id && (dataItem.employee_lastname || dataItem.employee_firstname)) {
            <div
              class="cw-flex-row cw-input">
              <span class="cw-input-label">{{ 'GENERAL.EMPLOYEE' | translate }}</span>
              <div class="cw-input-span">
                <span
                  >{{ dataItem.employee_lastname
                  }}@if (dataItem.employee_firstname) {
                  , {{ dataItem.employee_firstname }}
                  }</span
                  >
                </div>
              </div>
            }
            <!-- Timestamps -->
            @if (dataItem.id > 0) {
              <div>
                <phscw-output-timestamp
                  class="cw-flex-row"
                  label="{{ 'GENERAL.CREATION' | translate }}"
                  [timestamp]="dataItem.create_date"
                additional="{{ dataItem.create_user }}"></phscw-output-timestamp>
                <phscw-output-timestamp
                  class="cw-flex-row"
                  label="{{ 'GENERAL.ALTERATION' | translate }}"
                  [timestamp]="dataItem.edit_date"
                additional="{{ dataItem.edit_user }}"></phscw-output-timestamp>
              </div>
            }
            <!-- Buttons Submit & Cancel (für EditMode) -->
            @if (editMode) {
              <div class="cw-button-wrapper">
                <button
                  mat-raised-button
                  color="accent"
                  type="submit"
                  [disabled]="!institutionsNotesForm.form.valid || loading || saving">
                  {{ 'GENERAL.SAVE' | translate }} <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
                </button>
                <button mat-raised-button color="primary" type="button" (click)="clickCancel()">
                  {{ 'GENERAL.CANCEL' | translate }}
                </button>
              </div>
            }
          </form>
        }
      </div>
    }
